/* eslint-disable no-dupe-class-members,class-methods-use-this */
import { InternalDataLayer } from './internal-data-layer';
import { InternalQueue } from './internal-queue';
import { isEventWithCurrency, isPageViewEvent, transformCurrencyCode } from './utils';
export class Tracker {
    constructor() {
        this.trackWithQueue = (event, payload, options) => {
            var _a;
            // @ts-expect-error TODO: Fix this type error
            if (isEventWithCurrency(event) && payload && ((_a = payload[payload.event_name]) === null || _a === void 0 ? void 0 : _a.currency)) {
                /**
                 * In order to forward proper Romanian currency code to GA4,
                 * we need to transform it from LEI to RON. This hack is implemented here
                 * to avoid changing the currency code in other parts of the application.
                 */
                // @ts-expect-error TODO: Fix this type error
                // eslint-disable-next-line no-param-reassign
                payload[payload.event_name].currency = transformCurrencyCode(
                // @ts-expect-error TODO: Fix this type error
                payload[payload.event_name].currency);
            }
            this.track(event, payload, options);
            this.internalDataLayer.add(event, payload);
            if (isPageViewEvent(event)) {
                this.internalDataLayer.trackPageView();
            }
        };
        this.internalDataLayer = new InternalDataLayer();
        this.internalQueue = new InternalQueue(this.trackWithQueue);
    }
    track(event, payload, options) {
        let additionalData = {};
        if (payload) {
            additionalData = typeof payload === 'object' ? payload : { data: payload };
        }
        // eslint-disable-next-line no-restricted-properties
        window.dataLayer = window.dataLayer || [];
        if ((options === null || options === void 0 ? void 0 : options.eventCallback) && (options === null || options === void 0 ? void 0 : options.eventTimeout)) {
            additionalData.eventCallback = options.eventCallback;
            additionalData.eventTimeout = options.eventTimeout;
        }
        // eslint-disable-next-line no-restricted-properties
        window.dataLayer.push({ event, ...additionalData });
    }
}
//# sourceMappingURL=tracker.js.map